#import "./TrainingCourseAdminFields.graphql"

mutation CreateTrainingCourse(
  $courseInput: TrainingCourseInput!
  $singleModule: Boolean
) {
  createTrainingCourse(
    input: { courseInput: $courseInput, singleModule: $singleModule }
  ) {
    trainingCourse {
      ...TrainingCourseAdminFields
    }
    trainingModule {
      id
    }
  }
}
